module.exports = __webpack_public_path__ + "img/banner_left.db0938fc.jpg";